import { Lead } from '@/types/lead';

export const mockLeads: Lead[] = [
  {
    id: '1',
    name: 'Sarah Chen',
    company: 'TechVentures Singapore',
    title: 'Chief Financial Officer',
    industry: 'Technology',
    phone: '+65 9123 4567',
    email: 'sarah.chen@techventures.sg',
    status: 'new',
    preferredProduct: 'prushield',
    companySize: '50-200',
    painPoints: ['Employee health coverage', 'Rising healthcare costs']
  },
  {
    id: '2',
    name: 'Michael Tan',
    company: 'Innovative Solutions Pte Ltd',
    title: 'HR Director',
    industry: 'Manufacturing',
    phone: '+65 8765 4321',
    email: 'michael.tan@innovative.sg',
    status: 'contacted',
    lastContact: '2024-01-05',
    preferredProduct: 'pruactive',
    companySize: '200-500',
    painPoints: ['Employee wellness programs', 'Retention benefits']
  },
  {
    id: '3',
    name: 'Jennifer Lim',
    company: 'Global Logistics Asia',
    title: 'CEO',
    industry: 'Logistics',
    phone: '+65 9876 5432',
    email: 'jennifer@globallogistics.asia',
    status: 'qualified',
    preferredProduct: 'prushield',
    companySize: '500+',
    painPoints: ['Comprehensive coverage for field workers', 'Cost management']
  },
  {
    id: '4',
    name: 'David Wong',
    company: 'FinTech Innovations',
    title: 'Head of Operations',
    industry: 'Financial Services',
    phone: '+65 8234 5678',
    email: 'david.wong@fintech.sg',
    status: 'interested',
    lastContact: '2024-01-08',
    preferredProduct: 'pruactive',
    companySize: '50-200',
    painPoints: ['Premium employee benefits', 'Work-life balance initiatives']
  },
  {
    id: '5',
    name: 'Angela Koh',
    company: 'Creative Agency Plus',
    title: 'Managing Director',
    industry: 'Media & Advertising',
    phone: '+65 9345 6789',
    email: 'angela@creativeplus.sg',
    status: 'new',
    companySize: '10-50',
    painPoints: ['Affordable health coverage', 'Flexible plans for contractors']
  },
  {
    id: '6',
    name: 'Raymond Lee',
    company: 'Biotech Research Lab',
    title: 'VP of Human Resources',
    industry: 'Healthcare',
    phone: '+65 8456 7890',
    email: 'raymond.lee@biotechlab.sg',
    status: 'contacted',
    preferredProduct: 'prushield',
    companySize: '200-500',
    painPoints: ['Specialized coverage for research staff', 'Mental health support']
  }
];

export const getLeadById = (id: string): Lead | undefined => {
  return mockLeads.find(lead => lead.id === id);
};